import { ArrowDown, ArrowRight, ImagePlus, ScanLine, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Atmosphere } from '../components/Atmosphere';
import { fragranceDataset } from '../domain/fragrance/catalogue';
import { analytics } from '../services/analytics';

export function LandingPage() {
  return (
    <div className="landing-page">
      <Atmosphere />
      <section className="hero section-frame">
        <img className="hero-art" src="/images/style-hero-architecture.webp" alt="Abstract monochrome architectural planes" />
        <div className="hero-grain" aria-hidden="true" />
        <p className="hero-catalogue">STYLE / AESTHETIC INDEX<br />VOL. 01 — 2026</p>
        <div className="hero-title-lockup">
          <span className="hero-block hero-block-cyan" aria-hidden="true" />
          <span className="hero-block hero-block-pink" aria-hidden="true" />
          <p className="eyebrow">Visual DNA / Fragrance direction</p>
          <h1><span>THE</span><strong>INVISIBLE</strong><i>portrait.</i></h1>
          <p className="hero-quote">“Style leaves a trace before<br />a fragrance ever arrives.”</p>
          <Link className="button button-primary button-large" to="/discover" onClick={() => analytics.track('discovery_started')}>
            Begin discovery <ArrowRight size={18} />
          </Link>
        </div>
        <p className="hero-side-note">Images become an editable aesthetic reading—not a verdict about who you are.</p>
        <p className="hero-privacy">No account / source images not retained</p>
        <a href="#method" className="scroll-cue" aria-label="Read how it works"><ArrowDown /></a>
      </section>

      <section className="manifesto section-frame" id="method">
        <p className="phase-label"><span>Method 01</span> // A point of view, not a verdict</p>
        <h2>Your signature is not found. <em>It is constructed.</em></h2>
        <div className="method-grid">
          <article><ImagePlus /><span>01</span><h3>Bring references</h3><p>One to five images: clothes, rooms, objects, textures or artwork.</p></article>
          <article><ScanLine /><span>02</span><h3>Calibrate the reading</h3><p>Edit the visible aesthetic interpretation. You stay in control.</p></article>
          <article><Sparkles /><span>03</span><h3>Test five directions</h3><p>Deterministic roles create a varied, explainable starting set.</p></article>
        </div>
      </section>

      <section className="catalogue-note section-frame">
        <p>{fragranceDataset.dataset_metadata.record_count} sourced records / zero invented products</p>
        <h2>A finite catalogue.<br /><i>Transparent choices.</i></h2>
        <p>Missing product facts stay missing. STYLE never fills gaps with plausible-sounding perfume lore.</p>
      </section>
    </div>
  );
}
